document.addEventListener("DOMContentLoaded", () => {
	const btnHeroTranscriptToggler = document.getElementById(
		"home-artist-transcript-toggler",
	);

	if (btnHeroTranscriptToggler) {
		btnHeroTranscriptToggler.addEventListener("click", () => {
			var content = document.getElementById("transcript-home-artist-content");
			var button = content.querySelector("button");
			var isHidden = content.hasAttribute("hidden");

			if (isHidden) {
				content.removeAttribute("hidden");
				button.setAttribute("aria-expanded", "true");
			} else {
				content.setAttribute("hidden", "true");
				button.setAttribute("aria-expanded", "false");
			}
		});
	}
});
